/*
    此文件为数据接口存放命名，为防止接口太多，造成接口混乱
    命名为大写斜杠
    按页面划分
    例如： 'ORDER_API': '/api/order',
    每个接口注释用途，为方面其他开发人员查找，了解。
    export default {

    }
*/
export default {
  //原辅料耗用情况分页查询
  COST_LIST_API: '/produce/pdMaterialsConsumptionDetail/queryPage',
  //原辅料耗用情况详情
  COSTSDETAIL_LIST_API: '/produce/pdMaterialsConsumptionDetail/queryById',
  //耗用明细-删除
  // "COSTDETAILS_SAVE_API": "/produce/pdMaterialsConsumptionDetail/delete",
  //耗用明细-导出
  COSTDETAILS_SAVE_API: '/produce/pdMaterialsConsumptionDetail/exportExcel',
};
